// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 601 ? "component---src-pages-index-mdx" : chunkId) + "-" + {"108":"0b49dee4402cd64ac767","452":"e0239ebc16ecec20e6f8","601":"eed00148cdfd7f7bbc59"}[chunkId] + ".js";
};